import { render } from "./BigScreenLayout.vue?vue&type=template&id=2e7ad457&scoped=true"
import script from "./BigScreenLayout.vue?vue&type=script&lang=js"
export * from "./BigScreenLayout.vue?vue&type=script&lang=js"

import "./BigScreenLayout.vue?vue&type=style&index=0&id=2e7ad457&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e7ad457"]])

export default __exports__